// @flow
import * as Sentry from '@sentry/react';
import { conversations } from '../../services/api/scribe';
import type { ScribeCorrectionMode } from '../../types/config';

export const fetchTrainingFiles = () => async (dispatch: Function) => {
  try {
    const res = await conversations.getTrainingConversations();
    dispatch({
      type: 'FETCH_SCRIBE_TRAINING_SUCCESS',
      trainings: res.data,
    });
  } catch (e) {
    console.log('Failed to load training conversations');
    Sentry.captureException(e);
  }
};

export const scribeSetFontSize = (fontSize: number) => ({
  type: 'SCRIBE_SET_FONT_SIZE',
  fontSize,
});

export const setScribeCorrectionMode = (correctionMode: ScribeCorrectionMode) => ({
  type: 'SCRIBE_SET_CORRECTION_MODE',
  correctionMode,
});
